<template>
	<div>
		<div style="width: 85%; height: 50vh; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px">
			<div v-for="(variable, index) of variables" :key="variable.id">
				<div class="data-item">
					<div class="label">
						<strong>{{ variable.name }}</strong>
					</div>
					<div class="value">
						<field-type
							:ownerId="school.id"
							level="0"
							:field="variable"
							@focus="handleEdit"
							@image="
								e => {
									handleImage(index, e)
								}
							"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import FieldType from "./field-type"
export default {
	name: "school-secondary-form",
	components: {
		FieldType
	},
	props: ["element", "clear"],
	data() {
		return {
			school: { ...this.element },
			height: window.innerHeight - 325,
			edit: false,
			error: [],
			imageUrl: ""
		}
	},
	created() {
		this.doCustomField({ organization_id: this.element.id, level: 0 })
	},
	computed: {
		...mapGetters({
			variables: "organization/custom_fields"
		})
	},
	watch: {
		clear: function () {
			if (this.clear == undefined) return
			if (this.clear) {
				this.edit = false
				this.doCustomField({ organization_id: this.school.id, level: 0 })
			}
		}
	},

	methods: {
		...mapActions({
			doCustomField: "organization/doCustomField",
			updateCustomFieldImage: "organization/updateCustomFieldImage"
		}),

		handleEdit: function (value) {
			this.edit = value
			if (value) this.$emit("edit", value)
		},

		handleImage: function (index, e) {
			this.edit = true
			this.updateCustomFieldImage({ index: index, file: e })

			this.$emit("edit", true)
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-form";
</style>
